import { render, staticRenderFns } from "./SimuladosEmpresa.vue?vue&type=template&id=cc5a273a"
import script from "./SimuladosEmpresa.vue?vue&type=script&lang=js"
export * from "./SimuladosEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports